// extracted by mini-css-extract-plugin
export default {"root":"Dashboard_root__NOQ0x","welcomeBanner":"Dashboard_welcomeBanner__19pxy","button":"Dashboard_button__WTol9","selectContainer":"Dashboard_selectContainer__1QxEg"};